import configureStore from './configureStore';

export const { store, persistor } = configureStore();
